module.exports = __webpack_public_path__ + "img/mc-on1.44d60cd2.gif";